export function getFormDataBodyFromValues(
  teamId: string,
  action: string
): FormData {
  const formDataBody = new FormData();
  formDataBody.append('teamId', teamId);
  formDataBody.append('action', action);
  return formDataBody;
}
